







































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IDelegate } from "@/interfaces";
import ForgingService from "@/services/forging";

@Component
export default class ForgingStats extends Vue {
  @Prop({ required: true }) public delegates: IDelegate[];

  private totals: object = {};

  get activeDelegates() {
    return this.$store.getters["network/activeDelegates"];
  }

  @Watch("delegates")
  public onDelegatesChanged() {
    this.getTotals();
  }

  public created() {
    this.getTotals();
  }

  private getTotals(): void {
    if (!this.delegates) {
      return;
    }

    this.totals = ForgingService.totals(this.delegates);
  }

  private percentage(value: number): number {
    return (value / this.activeDelegates) * 100;
  }
}
